// http/api.ts
import axios from 'axios';
import { NEW_TOKEN_AWAITING_KEY } from '../utils/consts';
import { fetchRefreshTokens } from '../http/refresh';
import { projectConfig } from '../configs/projectConfig';

export const api = axios.create({
  baseURL: projectConfig.API_URL || '',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Интерцептор для добавления токена в заголовки
api.interceptors.request.use(config => {
  const userData = localStorage.getItem('userData');
  let token = null;

  if (userData) {
    token = JSON.parse(userData).token;
  }

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // Добавляем admin_info если он есть в конфиге
  if (config.adminInfo) {
    config.headers.admin_info = config.adminInfo;
    delete config.adminInfo;
  }

  return config;
});

// Интерцептор для обработки 401 ошибки и обновления токена
api.interceptors.response.use(
  response => response,
  async error => {
    if (axios.isCancel(error)) {
      console.warn('request canceled');
      return Promise.reject(error);
    }

    const originalRequest = error.config;
    const userData = localStorage.getItem('userData');

    if (error.response?.status === 401 && userData && !originalRequest._retry) {
      // Проверяем, не пытается ли уже другой запрос обновить токен
      if (localStorage.getItem(NEW_TOKEN_AWAITING_KEY) === 'true') {
        localStorage.setItem(NEW_TOKEN_AWAITING_KEY, 'false');
        return Promise.reject(error);
      }

      try {
        localStorage.setItem(NEW_TOKEN_AWAITING_KEY, 'true');
        originalRequest._retry = true;

        const { data: refreshData } = await fetchRefreshTokens();

        // Обновляем токен в localStorage
        const userDataObj = JSON.parse(userData);
        userDataObj.token = refreshData.tokens.access.token;
        localStorage.setItem('userData', JSON.stringify(userDataObj));

        // Повторяем оригинальный запрос с новым токеном
        originalRequest.headers.Authorization = `Bearer ${refreshData.tokens.access.token}`;
        return api(originalRequest);
      } catch (refreshError) {
        // Если ошибка при обновлении токена - очищаем localStorage и перезагружаем страницу
        if (refreshError.response?.status === 403 || refreshError.response?.status === 409) {
          localStorage.clear();
          window.location.reload();
        }
        return Promise.reject(refreshError);
      } finally {
        localStorage.setItem(NEW_TOKEN_AWAITING_KEY, 'false');
      }
    } else if (error.response?.status === 401) {
      // Если нет userData, но пришел 401 - очищаем localStorage
      localStorage.clear();
      window.location.reload();
    }

    return Promise.reject(error);
  }
);
